import type { TourDefinition } from "../types";

/**
 * Tour for /app/edit-visual. Explains draw-to-annotate, the action menu,
 * carousel navigation, and version history.
 */
export const editVisualTour: TourDefinition = {
  id: "edit-visual",
  label: "Edit a Visual",
  description: "Annotate, approve & re-generate",
  routeMatch: /^\/app\/edit-visual\/?$/,
  estimatedSeconds: 70,
  steps: [
    {
      target: "body",
      placement: "center",
      title: "The visual editor",
      body: "This is where you approve the shots you love and refine the ones that need changes. Draw a box on the image to mark an area you want changed.",
    },
    {
      target: '[data-tour="edit-visual.image"]',
      placement: "right",
      title: "Draw to annotate",
      body: "Click and drag on the image to draw a box around anything that needs changing. Then describe the change in the panel that appears.",
      showIf: () => !!document.querySelector('[data-tour="edit-visual.image"]'),
    },
    {
      target: '[data-tour="edit-visual.actions"]',
      placement: "left",
      title: "Actions menu",
      body: "Approve, Download, Re-generate, or Delete from this menu. Approving a visual sends it to the Asset Library automatically.",
      showIf: () => !!document.querySelector('[data-tour="edit-visual.actions"]'),
    },
    {
      target: '[data-tour="edit-visual.carousel"]',
      placement: "right",
      title: "Flip between visuals",
      body: "Use the arrows (or your keyboard's ← →) to jump between visuals in the same brief without leaving the editor.",
      showIf: () => !!document.querySelector('[data-tour="edit-visual.carousel"]'),
    },
  ],
};
